import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs/Rx';

import { MessageService } from 'primeng/components/common/messageservice';

import { environment } from '../../../environments/environment';
import { PerfilEnum } from '../base/enum/perfil';
import { BaseService } from '../base/util/base.service';
import { TokenInfo } from '../base/vo/token-info';
import { Usuario } from '../base/vo/usuario';


@Injectable()
export class AutenticacaoService extends BaseService {

  constructor(private router: Router,
    public http: HttpClient,
    public messageService: MessageService) {
    super(http, messageService);
  }

  private loginInfoBehaviorSubject = new BehaviorSubject<boolean>(false);
  public loginInfoObservable = this.loginInfoBehaviorSubject.asObservable();

  private usuarioLogadoBehaviorSubject: BehaviorSubject<Usuario> = new BehaviorSubject(null);
  public usuarioLogadoObservable: Observable<Usuario> = this.usuarioLogadoBehaviorSubject.asObservable();

  private getUrl(username: string) {
    if (username === 'admin' || username === 'marketing') {
      return environment.urlLoginAdmin;
    } else {
      return environment.urlLogin;
    }
  }

  login(usuarioLogin: Usuario): Observable<Usuario> {
    const url = this.getUrl(usuarioLogin.username) + 'login';

    return this
      .http
      .post(url, usuarioLogin)
      .map((response: any) => {
        return this.validarInformacoesToken(response);
      });
  }

  atualizarToken(): Observable<Usuario> {
    const tokenInfo =
      new TokenInfo(this.usuarioLogado.tokenAcess, this.usuarioLogado.tokenRefresh);

    let url = this.getUrl(this.usuarioLogado.username) + 'refresh-token/{username}';
    url = this.setParametro(url, 'username', this.usuarioLogado.username);
    return this.http
      .put(url, tokenInfo)
      .debounceTime(300)
      .switchMap(response => {
        return Observable.of(this.validarInformacoesToken(response));
      });

  }

  logout() {
    localStorage.removeItem('usuario-logado');
    localStorage.removeItem('imagem-perfil');
    this.limparBuscaGto();
    localStorage.removeItem('alterar-senha-sugerido');

    this.usuarioLogadoBehaviorSubject.next(null);
    this.loginInfoBehaviorSubject.next(false);
    this.router.navigate(['/login']);
  }

  get usuarioLogado(): Usuario {
    let usuario: Usuario = null;

    if (localStorage.getItem('usuario-logado')) {
      usuario = JSON.parse(localStorage.getItem('usuario-logado'));
      this.usuarioLogadoBehaviorSubject.next(usuario);
    }

    return usuario;
  }

  get isPrestador(): boolean {
    return this.usuarioLogado && this.usuarioLogado.perfil === PerfilEnum.PRESTADOR;
  }

  get isAdministrador(): boolean {
    return this.usuarioLogado && this.usuarioLogado.perfil === PerfilEnum.ADMIN;
  }

  get isMarketing(): boolean {
    return this.usuarioLogado && this.usuarioLogado.perfil === PerfilEnum.MARKETING;
  }

  get isClinica(): boolean {
    return this.usuarioLogado.pessoaJuridica;
  }

  get tokenAcess(): string {
    let retorno = null;
    if (this.usuarioLogado) {
      retorno = this.usuarioLogado.tokenAcess;
    }
    return retorno;
  }

  get tokenRefresh(): string {
    let retorno = null;
    if (this.usuarioLogado) {
      retorno = this.usuarioLogado.tokenRefresh;
    }
    return retorno;
  }

  public isUsuarioLogado(): boolean {
    let isLogado = false;
    if (this.usuarioLogado) {
      isLogado = true;
    }
    return isLogado;
  }

  public validarInformacoesToken(response: any): Usuario {
    const tokenExiste = response && response.tokenAcess && response.tokenRefresh;

    let usuario = null;
    if (tokenExiste) {
      const token = JSON.parse(atob(response.tokenAcess.split('.')[1]));

      usuario = token.usr;
      usuario.perfil = Usuario.converterPerfil(token.usr.perfil);
      usuario.tokenAcess = response.tokenAcess;
      usuario.empresa = token.empresa;
      usuario.tokenRefresh = response.tokenRefresh;
      localStorage.setItem('usuario-logado', JSON.stringify(usuario));

      this.usuarioLogadoBehaviorSubject.next(usuario);
      this.loginInfoBehaviorSubject.next(true);
    }
    return usuario;
  }

  public limparBuscaGto() {
    localStorage.removeItem('efetuar-busca-gto');
    localStorage.removeItem('filtro-busca-gto');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/autenticacao/autenticacao.service.ts